var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61376 1.66741C4.61352 2.10941 4.41669 2.53322 4.06659 2.84561C3.71648 3.158 3.24177 3.33337 2.7469 3.33315C2.25202 3.33293 1.77751 3.15713 1.42776 2.84443C1.078 2.53173 0.88165 2.10774 0.881897 1.66574C0.882145 1.22374 1.07897 0.799926 1.42908 0.487539C1.77918 0.175152 2.25389 -0.000220793 2.74876 2.08623e-07C3.24364 0.00022121 3.71815 0.176018 4.0679 0.488718C4.41766 0.801417 4.61401 1.2254 4.61376 1.66741ZM4.66974 4.56725H0.937875V15H4.66974V4.56725ZM10.5661 4.56725H6.85288V15H10.5288V9.5253C10.5288 6.47547 14.979 6.19216 14.979 9.5253V15H18.6642V8.39203C18.6642 3.25065 12.0775 3.44231 10.5288 5.96717L10.5661 4.56725Z",
    fill: "#C4E332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdn);
export default __webpack_public_path__ + "static/media/linkdn.824c73cda4d20ae01e60f994ed0aeb83.svg";
export { ForwardRef as ReactComponent };